import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { useDebounce } from '../../../../hooks/use-debounce'
import { GET_USERS } from './queries'
import { Users } from './users'

export function UsersContainer() {
    const [search, setSearch] = useState('')
    const debouncedSearch = useDebounce({ value: search, delay: 500 })
    const { data, loading } = useQuery(GET_USERS, {
        variables: {
            filter: {
                email: { contains: debouncedSearch },
            },
        },
    })

    return (
        <Users
            search={search}
            users={data?.listUserProfiles?.items ?? []}
            setSearch={setSearch}
            loading={loading}
        />
    )
}
